// extracted by mini-css-extract-plugin
module.exports = {"Component":"skill_Component__3DQ7n","Left":"skill_Left__11GCQ","Right":"skill_Right__2M6gv"};